import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import SignInSide from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import ResetPassword from "../pages/ResetPassword";
import ForgotPassword from "../pages/ForgotPassword";
import DeleteAccount from "../pages/DeleteAccount";
import { Delete } from "@material-ui/icons";

export default function NonAuthenticatedRoutes() {
    return (
        <BrowserRouter  >
            <Switch>
                <Route exact path="/login">
                    <SignInSide />
                </Route>
                <Route exact path="/register">
                    <SignUp />
                </Route>
                <Route exact path="/forgot">
                    <ForgotPassword />
                </Route>
                <Route exact path="/reset">
                    <ResetPassword />
                </Route>
                <Route exact path="/delete">
                    <DeleteAccount />
                </Route>
                <Route path="**">
                    <SignInSide />
                </Route>
            </Switch>
        </BrowserRouter>
    )
}